import { useTranslation } from 'react-i18next';

import { Box, Flex, forwardRef, Heading, Link, rem } from '@bonusly/design-system';

export interface NotificationHeaderProps {
	handleReadAll: VoidFunction;
}
export const NotificationHeader = forwardRef(({ handleReadAll }: NotificationHeaderProps, ref) => {
	const { t } = useTranslation('navigation');
	return (
		<Box w="100%" p={0}>
			<Flex justifyContent="space-between" alignItems="flex-end" flexDir="row" w="100%" h={rem(52)}>
				<Heading pl={rem(12)} size="2xl">
					{t('notification.header')}
				</Heading>

				<Link pr={rem(12)} onClick={handleReadAll} pb={rem(6)} textColor="primary.fgStrong" as="a" tabIndex={0} ref={ref} cursor="pointer" listStyleType="none">
					{t('notification.read_all')}
				</Link>
			</Flex>
		</Box>
	);
});
